import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import {valueChainTreeUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {ValueChainTree} from "~/pages/supplier-360/tabs/SupplierValueChain/valueChainLinkTypes";

/**
 * The unlocked entity's chain as a tree (§2.17). Mount it only once the entity is unlocked (§3.9) —
 * an empty tree after unlocking is a real answer, not a loading state.
 */
export function useValueChainTreeQuery(entityId: number) {
    const url = valueChainTreeUrl(entityId);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<ValueChainTree>(url)).data,
    });
}
